<igo-form
  #igoForm
  [form]="form()"
  [formData]="feature()"
  (submitForm)="onSubmit($event)"
>
  <ng-content />

  <ng-content select="[formButtons]" formButtons />
</igo-form>
